import { render } from "./RearrangeSpeakersModal.vue?vue&type=template&id=5e23aaff&scoped=true"
import script from "./RearrangeSpeakersModal.vue?vue&type=script&lang=js"
export * from "./RearrangeSpeakersModal.vue?vue&type=script&lang=js"

import "./RearrangeSpeakersModal.vue?vue&type=style&index=0&id=5e23aaff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e23aaff"]])

export default __exports__